module.exports = __webpack_public_path__ + "static/media/MHRP09N0027.74c92f60.svg";